(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ss-3d-tour"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('message',function(event){
 if(event.origin!=='https://stripe-show-trailer-walkthrough.blushcrow1.chatgpt.site')return;
 const data=event.data;
 if(!data||data.type!=='stripe-show-tour-height'||!Number.isFinite(data.height)||data.height<300||data.height>20000)return;
 document.querySelectorAll('iframe[data-ss-full-tour]').forEach(function(frame){
  if(frame.contentWindow===event.source)frame.style.height=Math.ceil(data.height)+'px';
 });
});
function measureFullTours(){document.querySelectorAll('iframe[data-ss-full-tour]').forEach(function(frame){if(frame.dataset.tourMeasureReady)return;frame.dataset.tourMeasureReady='true';const measure=function(){frame.contentWindow.postMessage({type:'stripe-show-tour-measure'},'https://stripe-show-trailer-walkthrough.blushcrow1.chatgpt.site');};frame.addEventListener('load',measure);measure();});}
measureFullTours();
document.addEventListener('shopify:section:load',measureFullTours);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-parties-events"]) return;
  try {
    
(() => {
  function initPartyPricing(scope = document) {
    scope.querySelectorAll('[data-party-calculator]').forEach(panel => {
      if (panel.dataset.ready) return;
      panel.dataset.ready = 'true';
      const slider = panel.querySelector('[data-party-duration]');
      const money = value => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD',maximumFractionDigits:0}).format(value);
      const update = () => {
        const hours = Math.max(3, Math.min(8, Number(slider.value) || 3));
        panel.querySelector('[data-party-hours]').textContent = String(hours);
        panel.querySelector('[data-party-duration-label]').textContent = String(hours);
        panel.querySelector('[data-party-play]').textContent = money(hours * 199);
        panel.querySelector('[data-party-total]').textContent = money(250 + hours * 199);
      };
      slider.addEventListener('input', update);
      update();
    });
  }
  initPartyPricing();
  document.addEventListener('shopify:section:load', event => initPartyPricing(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-quote-form"]) return;
  try {
    
const quoteForm=document.getElementById('StripeShowQuote');
if(quoteForm){
 const start=quoteForm.querySelector('#ssq-start_date');
 const end=quoteForm.querySelector('#ssq-end_date');
 if(start&&end){
  const syncDates=()=>{end.min=start.value;if(end.value&&start.value&&end.value<start.value)end.value=start.value;};
  start.addEventListener('change',syncDates);syncDates();
 }
 const success=quoteForm.querySelector('.ssq-success');
 if(success)success.focus();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stripe-show-home"] && !Shopify.designMode) return;
  try {
    

/* Heading wrapping is handled by the reference stylesheet. */

(() => {
  function initHeroScenes(scope = document) {
    scope.querySelectorAll('[data-hero-scenes]').forEach(hero => {
      if (hero.dataset.scenesReady) return;
      hero.dataset.scenesReady = 'true';
      const slides = [...hero.querySelectorAll('[data-hero-slide]')];
      const controls = hero.querySelector('[data-hero-controls]');
      const buttons = [...controls.querySelectorAll('[data-scene-choice]')];
      const toggle = controls.querySelector('[data-scene-toggle]');
      const label = controls.querySelector('[data-scene-label]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, paused = reduced.matches, timer = null, visible = true, busy = false, alive = true, revision = 0;
      const ready = slide => {
        if (slide.dataset.src) { slide.src = slide.dataset.src; delete slide.dataset.src; }
        if (slide.complete) return Promise.resolve(slide.naturalWidth > 0);
        return new Promise(resolve => {
          slide.addEventListener('load', () => resolve(true), {once:true});
          slide.addEventListener('error', () => resolve(false), {once:true});
        });
      };
      const stop = () => { clearInterval(timer); timer = null; };
      const render = () => {
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        label.textContent = buttons[index].dataset.sceneName;
        toggle.textContent = paused ? controls.dataset.play : controls.dataset.pause;
        toggle.setAttribute('aria-label', paused ? controls.dataset.playLabel : controls.dataset.pauseLabel);
      };
      const canRun = () => alive && !paused && visible && !document.hidden;
      const select = async (next, manual = false) => {
        if (busy && !manual) return;
        const request = ++revision; busy = true;
        const loaded = await ready(slides[next]);
        if (request !== revision || !alive) return;
        busy = false;
        if (!loaded || (!manual && !canRun())) return;
        index = next; render(); ready(slides[(index + 1) % slides.length]);
      };
      const schedule = () => {
        stop();
        if (canRun()) timer = setInterval(() => select((index + 1) % slides.length), 3000);
      };
      buttons.forEach((button, i) => button.addEventListener('click', () => {
        paused = true; stop(); select(i, true); render();
      }));
      toggle.addEventListener('click', () => { paused = !paused; render(); schedule(); });
      const onVisibility = () => schedule();
      const onMotion = () => { if (reduced.matches) paused = true; render(); schedule(); };
      document.addEventListener('visibilitychange', onVisibility);
      reduced.addEventListener('change', onMotion);
      const observer = new IntersectionObserver(items => {
        visible = items[0].isIntersecting; schedule();
      }, {threshold:0.15});
      observer.observe(hero);
      const unload = event => {
        if (!event.target.contains(hero)) return;
        alive = false; stop(); observer.disconnect();
        document.removeEventListener('visibilitychange', onVisibility);
        reduced.removeEventListener('change', onMotion);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      controls.hidden = false; render(); ready(slides[1]); schedule();
    });
  }
  initHeroScenes();
  document.addEventListener('shopify:section:load', event => initHeroScenes(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
